import { getErrorData } from "helpers";
import { ProblemDetails } from "models/ProblemDetails";
import { toast } from "react-toastify";

export const toastSuccess = (message: string): void => {
  toast.success(message, {
    hideProgressBar: false,
    delay: 0,
    autoClose: 2000,
    toastId: "success",
    className: "toast-success",
  });
};

export const toastWarning = (message: string, warnings?: string[]): void => {
  const content = formatContent(message, undefined, undefined, warnings);

  toast.warn(content, {
    hideProgressBar: true,
    autoClose: 0,
    className: "toast-warning",
  });
};

function formatContent(message: string, title?: string, reason?: string, errors?: string[]) {
  const hash = new Set<string>();
  hash.add(message);

  if (title && !hash.has(title)) {
    hash.add(title);
  }

  if (reason && !hash.has(reason)) {
    hash.add(reason);
  }

  (errors || []).forEach((x) => {
    if (!hash.has(x)) {
      hash.add(x);
    }
  });

  const parts = Array.from(hash.entries()).map((x, i) => (
    <div key={i} className={i > 0 ? "toast-detail" : ""}>
      {x[1]}
    </div>
  ));

  return <div>{parts}</div>;
}

export const toastError = (message: string, error?: unknown): void => {
  const problemDetails = getErrorData<ProblemDetails>(error);
  const content = formatContent(
    message,
    problemDetails?.title,
    problemDetails?.reason,
    mapErrorsToArray(problemDetails?.errors)
  );
  toast.error(content, { hideProgressBar: true, delay: 0, autoClose: false, className: "toast-error" });
};

export const mapErrorsToString = (errors?: Record<string, string[]>): string => {
  return mapErrorsToArray(errors).join(", ");
};

export const mapErrorsToArray = (errors?: Record<string, string[]>): string[] => {
  const safeErrors = errors || [];
  const results: string[] = [];
  Object.entries<string[]>(safeErrors).map(([, keyErrors]) => {
    keyErrors.forEach((e) => results.push(e));
    return null;
  });
  return results;
};
